import { COLORS } from 'helpers/globals'

export const removeIcon = {
  fontSize: '2rem',
  margin: '0 .5rem 0 2rem',
  color: '#fd9999',
  transition: 'color 200ms, opacity 200ms',
  '&:hover': { color: 'red' },
  '&.disabled': {
    opacity: .75,
    color: COLORS.secondary,
    cursor: 'not-allowed'
  }
}

export default {
  config: {
    display: 'contents'
  },
  nameWrapper: {
    display: 'flex',
    alignItems: 'center',
    color: 'black',
    margin: '0 .75rem',
    position: 'sticky',
    top: '-5px',
    zIndex: 1,
    '&.even': { background: '#ebebeb' },
    '&.odd': { background: 'white' },
    '& input': {
      flex: '1 1 auto',
      marginLeft: '.75rem',
      background: 'white !important',
      borderRadius: '.5rem !important'
    }
  },
  removeIcon,
  background: {
    gridRow: '1 / -1',
    borderRadius: '1rem',
    marginBottom: '5px',
    zIndex: -2,
    boxShadow: `0 0 2px 1px ${COLORS.quaternary}`,
    '&.highlight': { boxShadow: `0 0 4px 1px ${COLORS.primary}` },
    '&.even': { background: '#ebebeb' },
    '&.odd': { background: 'white' }
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorControllerDesigner/DoorConfiguration/style.js